import { Grid, Tooltip, Typography } from '@material-ui/core';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import QCXBox from '../../shared-components/box/QCXBox';
import QCXButton from '../../shared-components/button/QCXButton';
import QCXFinalCheckboxField from '../../shared-components/final-checkbox-field/QCXFinalCheckboxField';
import QCXFormTitle from '../form-title/QCXFormTitle';
import { ACESSOS_TABELA_ADUANEIRA, ACESSOS_ACESSOS_TABELA_ADUANEIRA_NAME_MAP, userHasRole } from './perfil-utils';

export default function QCXTabelasAduaneirasTabForm({
  isConsult,
  form,
  values,
  authInfo = {},
}) {
  const { t } = useTranslation();

  const checkAll = () => {
    form.change('permissoesAcesso', _.union(values.permissoesAcesso, ACESSOS_ACESSOS_TABELA_ADUANEIRA_NAME_MAP).filter((item) => userHasRole(authInfo, item)));
  };
  const uncheckAll = (formValues) => () => {
    const removed = formValues?.permissoesAcesso.filter(
      (item) => !ACESSOS_ACESSOS_TABELA_ADUANEIRA_NAME_MAP.includes(item)
    );
    form.change('permissoesAcesso', removed);
  };
  const checkColum = (column) => () => {
    const checkedValues = values?.permissoesAcesso?.filter((item) => item.endsWith(column));
    const selectedColumn = ACESSOS_ACESSOS_TABELA_ADUANEIRA_NAME_MAP.filter(
      (item) => item.endsWith(column)
    ).filter((item) => userHasRole(authInfo, item));
    const checkedColumnValues = checkedValues.filter(
      (item) => ACESSOS_ACESSOS_TABELA_ADUANEIRA_NAME_MAP.includes(item)
    );
    if (checkedColumnValues.length) {
      const removed = values?.permissoesAcesso.filter(
        (item) => !selectedColumn.includes(item)
      );
      form.change('permissoesAcesso', removed);
      return;
    }
    form.change('permissoesAcesso', _.union(values.permissoesAcesso, selectedColumn));
  };
  const checkLine = (line) => () => {
    const checkedValues = values?.permissoesAcesso?.filter((item) => item.startsWith(line));
    const selectedLine = ACESSOS_ACESSOS_TABELA_ADUANEIRA_NAME_MAP.filter(
      (item) => item.startsWith(line)
    ).filter((item) => userHasRole(authInfo, item));
    const checkedLinesValues = checkedValues.filter(
      (item) => ACESSOS_ACESSOS_TABELA_ADUANEIRA_NAME_MAP.includes(item)
    );
    if (checkedLinesValues.length) {
      const removed = values?.permissoesAcesso.filter(
        (item) => !selectedLine.includes(item)
      );
      form.change('permissoesAcesso', removed);
      return;
    }
    form.change('permissoesAcesso', _.union(values.permissoesAcesso, selectedLine));
  };
  return (

    <>
      <QCXFormTitle title={t('com.muralis.qcx.acessosPerfil')} />
      <Grid container spacing={2}>
        <Grid item container spacing={1} xs={12} sm={12} md={8}>

          <Grid item xs={6} sm={6} md={6} />
          <Grid item xs={6} sm={6} md={6}>
            <Typography style={{ cursor: 'pointer' }} disabled={isConsult} onClick={checkColum('-visualizar')} color="primary">
              <QCXBox>
                {t('com.muralis.qcx.acoes.visualizar')}
              </QCXBox>
            </Typography>

          </Grid>
          {ACESSOS_TABELA_ADUANEIRA.map((item) => (
            <>
              <Grid item xs={6} sm={6} md={6}>
                <Typography
                  color="primary"
                  style={isConsult ? {} : { cursor: 'pointer' }}
                  onClick={isConsult ? () => {} : checkLine(item.name)}
                >
                  <QCXBox fontWeight="fontWeightBold">
                    {item.label}
                  </QCXBox>
                </Typography>
              </Grid>
              <Grid item xs={6} sm={6} md={6} style={{ paddingLeft: '0.8vh' }}>
                <Tooltip
                  title={!isConsult && !userHasRole(authInfo, `${item.name}-visualizar`) ? t('com.muralis.qcx.mensagem.concessaoPermissao') : ''}
                  placement="top-start"
                  aria-label={t('com.muralis.qcx.validacao.semPermissao')}
                >
                  <span>
                    <QCXFinalCheckboxField
                      name="permissoesAcesso[]"
                      disabled={isConsult || !userHasRole(authInfo, `${item.name}-visualizar`)}
                      value={`${item.name}-visualizar`}
                      too
                    />
                  </span>
                </Tooltip>
              </Grid>

            </>
          ))}
          <Grid item xs={12} sm={6} md={3} style={{ marginTop: '1rem' }}>
            <QCXButton
              onClick={checkAll}
              color="primary"
              disabled={isConsult}
            >
              {t('com.muralis.qcx.acoes.marcarTodos')}
            </QCXButton>
          </Grid>
          <Grid item xs={12} sm={6} md={3} style={{ marginTop: '1rem' }}>
            <QCXButton
              onClick={uncheckAll(values)}
              color="primary"
              disabled={isConsult}
            >
              {t('com.muralis.qcx.acoes.desmarcarTodos')}
            </QCXButton>
          </Grid>
        </Grid>

      </Grid>
    </>
  );
}
